import { Box, Dialog, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import AddDomainForm from "./AddDomainForm";

// Popup modal for registering a new domain. The 4-step wizard (blue left rail,
// fields, lookup, create request) lives in AddDomainForm; this is just the flat
// white dialog shell with a floating close button.
function AddDomainModal({ open, onClose, onSuccess, editId }) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      slotProps={{
        paper: {
          sx: {
            borderRadius: "16px",
            background: "#fff",
            border: "1px solid #EEF1F6",
            boxShadow: "0 24px 64px rgba(16, 24, 40, 0.18)",
            backgroundImage: "none",
            overflow: "hidden",
          },
        },
      }}
    >
      <Box sx={{ position: "relative" }}>
        <IconButton
          onClick={onClose}
          aria-label="Close"
          sx={{
            position: "absolute",
            top: 10,
            right: 10,
            zIndex: 2,
            color: "#64748B",
            background: "rgba(255,255,255,0.85)",
            "&:hover": { background: "#F8FAFC", color: "#0F172A" },
          }}
        >
          <CloseIcon />
        </IconButton>
        <AddDomainForm onSuccess={onSuccess} onCancel={onClose} editId={editId} />
      </Box>
    </Dialog>
  );
}

export default AddDomainModal;
